import { render, staticRenderFns } from "./TeamStats.vue?vue&type=template&id=119759c8&"
import script from "./TeamStats.vue?vue&type=script&lang=js&"
export * from "./TeamStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports